import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchPermission = createAsyncThunk(
    'permission/list', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/permission/list`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data.data;
        } catch (error) {
            console.error('Error fetching permission:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch permission');
        }
    }
);

export const assignPermission = createAsyncThunk(
    'role/assign-permission', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/role/assign-permission/${items.id}`, {
                ids : items.ids
            }, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data;
        } catch (error) {
            console.error('Error assign permission:', error);
            return rejectWithValue(error.response?.data || 'Failed to assign permission');
        }
    }
);

const permissionSlice = createSlice({
    name: 'permissions',
    initialState: {
        permissions: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermission.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchPermission.fulfilled, (state, action) => {
                state.isLoading = false;
                state.permissions = action.payload;
            })
            .addCase(fetchPermission.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(assignPermission.fulfilled, (state, action) => {
                state.permissions.push(action.payload.data);
            })
    },
});

export default permissionSlice.reducer;
